import $ from 'jquery';
import {BaseHandler} from "./BaseHandler";
import {NavigableTable} from "./NavigableTableHandler";
import {Reporter} from "../Api/Types";
import {Popup} from "../Popups/Popup";

export class ManageReportersHandler extends BaseHandler {
    private navigableTable: NavigableTable<Reporter>

    private buildRow(e: Reporter, data_extended: string = "false") {
        const row = this.get_template_jquery<HTMLTableRowElement>("reporter-row-template");

        const notes = row.find('[data-content-type="notes"]');
        row.find('[data-content-type="name"]').text(e.name);
        row.find('[data-content-type="emails"]').text(e.emails);
        notes.text(e.notes);
        row.find('[data-action="modify-row"]').on("click", () => this.modify_row(e, row));

        notes.attr("data-extended", data_extended)

        notes.on("dblclick", (e: JQuery.DoubleClickEvent) => {
            e.preventDefault();
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges(); // Clear any selected text
            }

            notes.attr("data-extended", notes.attr("data-extended") === "true" ? "false" : "true")
        })

        return row;
    }

    private modify_row(reporter: Reporter, row: JQuery) {
        const email_regex = /[a-zA-Z0-9.\-_]{3,}@[a-zA-Z]{3,}.[a-zA-Z]{2,}/;

        const title = this.get_template_text("change-reporter-row-title-template");
        const actual_notes = row.find('[data-content-type="notes"]').text();
        const actual_email = row.find('[data-content-type="emails"]').text();
        const popup_jq = this.get_template_jquery("change-batch-row-template");

        const x = Popup.DirectInject(popup_jq, title + reporter.name, true);
        x.popup.SetShowCloseCross();
        x.popup.SetShowActions();

        const email_inp = $("#new-reporter-email-input")
        email_inp.val(actual_email);

        const note_inp = $("#new-reporter-note-input");
        note_inp.val(actual_notes);


        const rename = (emails: string, note: string) => {
            this.client.update_reporter(reporter.reporter_id, emails, note).done(() => {
                reporter.emails = emails;
                reporter.notes = note;
                console.log(row.find('[data-content-type="notes"]').attr("data-extended"));
                row.replaceWith(this.buildRow(reporter, row.find('[data-content-type="notes"]').attr("data-extended")))
                x.popup.Remove();
            })
        }

        // Validator functions
        const isValidNotes = (notes: string): string | null => {
            if (notes.length > 512)
                return this.get_template_text("change-reporter-notes-too-long-template");
        }

        const isValidMail = (emails: string): string | null => {
            const effective_emails = emails.split(",")
            if (emails.length > 128)
                return this.get_template_text("change-reporter-mail-too-long-template");

            for (const email of effective_emails) {
                if (email === "")
                    return this.get_template_text("change-reporter-mail-empty-template");
                if (!email_regex.test(email))
                    return this.get_template_text("change-reporter-mail-invalid");
            }

            return null;
        };

        const on_confirm = (deferred: JQuery.Deferred<any>) => {
            deferred.done(d => {
                const mail_val = email_inp.val().toString().trim().replace(/\s+/g, "");
                email_inp.val(mail_val);
                const note_val = note_inp.val().toString().trim().replace(/ +/g, " ");
                note_inp.val(note_val);

                // Collect all errors
                const errors: string[] = [];

                const mailError = isValidMail(mail_val);
                if (mailError) errors.push(mailError);

                const notesError = isValidNotes(note_val);
                if (notesError) errors.push(notesError);

                // If there are errors, display them
                if (errors.length > 0) {
                    const error_message = "<div>" + errors.join("<div></div>") + "</div>"
                    x.popup.ShowError(error_message, true);
                } else {
                    // No errors, proceed with renaming
                    rename(mail_val, note_val);
                }

                on_confirm(d);
            });

            deferred.fail(() => x.popup.Remove());
        };

        on_confirm(x.deferred);

        this.navigableTable.drop_current();
    }


    private synchronize() {
        $('[data-action="synchronize"]').prop('disabled', true);

        this.client.synchronize_reporters().ew_done(() => {
            this.navigableTable.drop_current();
            this.navigableTable.update();

            this.success_popup("Fatto!");
        }).always(() => {
            $('[data-action="synchronize"]').prop('disabled', false);
        });
    }

    public override handle() {
        super.handle();

        $('[data-action="synchronize"]').on("click", () => {
            this.synchronize();
        })

        const tableWrapper = $('#table-wrapper-manage-reporters');
        this.navigableTable = new NavigableTable(tableWrapper, e => {
            return this.buildRow(e)
        }, (page_index, items_per_page) => {
            return this.client.get_reporters(items_per_page, page_index);
        });

        this.navigableTable.drop_cache();
        this.navigableTable.update();
    }
}